<template>
  <div id="app">
    <wen-vant-preview v-model="showPreview" :click-close="true" :list="previewList" ref="wen-vant-preview" :config="previewConfig" :traceability.sync="traceability" @clear="clear">
      <template v-slot="{item, index}">
        <span :style="{color: `${item.color}`, 'display': 'flex','height': '100%','align-items': 'center','justify-content': 'center'}">
          {{ item.name }}----{{ index + 1 }}
        </span>
        <button @click="itemClick">click</button>
      </template>
      <template #indicator="{current}">
        <div style="color: red;position: absolute;top: 10px;left: 20px;font-size: 36px;">
          {{current + 1}} / {{previewList.length}}
        </div>
      </template>
      <template #cover="{index}">
        <div >{{index}}</div>
      </template>
    </wen-vant-preview>
    <van-button type="primary" @click="vantClick($event)">预览测试</van-button>
  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      showPreview: false,
      traceability: null,
      previewList: [
        {
          id: 1,
          src: 'http://gips3.baidu.com/it/u=3886271102,3123389489&fm=3028&app=3028&f=JPEG&fmt=auto?w=1280&h=960',
          fileType: 1
        },
        {
          id: 4,
          src: 'http://gips2.baidu.com/it/u=1674525583,3037683813&fm=3028&app=3028&f=JPEG&fmt=auto?w=1024&h=1024',
          fileType: 1
        },
      ],
      previewConfig: {
        type: 'fileType', // 用于区分视频还是图片的字段
        videoType: 2,     // 视频类型的判断值
        imageType: 1,      // 图片类型的判断值
      }
    };
  },
  methods: {
    vantClick (event) {
      this.traceability = event.target
      this.showPreview = true
    },
    previewClick (event, index) {
      console.log(event, index, 'previewClick')
    },
    previewChange (index) {
      console.log(index, 'previewChange')
    },
    itemClick() {
      this.$refs["wen-vant-preview"].swipeTo(3, {immediate: false})
    },
    clear() {
      console.log('clear')
    }
  }
};
</script>
